<template>
  <div id="taisuijin">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>太歲金</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">太歲金</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/tai-sui-jin.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『太歲金』</h5>

                <p class="project-description">
                  <span><b>为何要焚化 “太岁金”？ </b></span>
                </p>

                <p class="project-description">
                  每一年都有四个生肖触犯 太岁神，为了避免触犯
                  太岁神，给自己带来疾病和 灾灾祸，须安奉太岁。
                </p>

                <p class="project-description">
                  对于四个生肖本命之年 的人来说， 也就要提醒自己
                  供奉太岁的神位，如今只要 购买諸葛孔明有限公司的太
                  岁殿焚化即可。 •在本命之年 小心谨慎，遵纪守法，多做
                  善事，注意冷暖，因为焚化 太岁殿只是消去了太岁刑冲
                  而己，并未转化太岁神的对 峙化为助力，即由敌对变成
                  两不相干。如果再能购买诸 葛孔明有限公司的“太岁金 ”焚化"。
                </p>

                <p class="project-description">
                  "太岁金"就是苗大大师为了那些生肖触发太岁神的人，能太岁护佑平安和
                  顺利的效能。当然如果不经 过苗大大师施法开光点化，
                  在自然印制小商贩手里购买 的，那么，自然是无效的。
                </p>

                <p class="project-description">
                  太岁神是年岁之神。道 德经籍中说， ，太岁神主管人
                  的“本生身命之灾”和“流 年临犯之厄” 。这就是说
                  人的一生的吉凶祸福是由太 岁神主管的。人的每一年的
                  健康或者疾病， 每一年运气 的顺当或者不利，也都是由
                  太岁神处理的。
                </p>

                <p class="project-description">
                  因此，我们焚化“太岁 金”获得太岁神的关怀， 使
                  为了祈求太岁神护佑自身身体的健康平安和流年的大吉大利。
                </p>

                <p class="project-description">
                  <span><b>※冲犯太歲何需到處求拜 </b></span>
                  苗大大師為您解千愁
                  沖犯太歲的人只要購買一個諸葛孔明公司所製的太歲殿，将内附的兩份表格填好，一份是印在太歲殿後。另一份在信封内，将這份信封内的表格填寫好後，寄回給諸葛孔明公司，讓苗大大師整年為您誦經加持。印在太歲殿後的表格填寫好後，将太歲殿安置在家中的神檯或者另置一個位置就一樣可以!太歲殿内置有三寶和北斗七星陣，那就是可以将太歲的煞氣轉化為助力，正所謂的化干戈為玉帛。您的名字在太崴殿後，即可受到靈力的保佑，順順利利，大吉大利。
                  安奉太歲的最好時間是由大年初一到達清明，任何時刻都可以安上，也只要将本身的名字出生的年月時，點燃三支清香膜拜安奉好的太歲殿前禀告一番，早晚點燃三支清香就可以。到達冬至過後未至新年之前，就可将所安太歲送回天庭，送太歲回天庭時，只要點燃三支香，並在太歲前祈禱：
                </p>

                <p class="project-description">
                  本人．．．．．．．．出生於．．．．．．．年．．．．．．月．．．．．．．日．．．．．時。现送；太歲回天庭，謝謝太歲一年的照顅，得以平安無事。過後将之當天焚化即可。若沒有時間安奉膜拜，也可以在填寫寄回給公司的回條上註明，然後將太歲殿當天焚化也可。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="tai-sui-jin" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "TaiSuiJin",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/TaiSuiJin.vue